import React from "react";
import R from "ramda";
import styled from "styled-components";
import { compose, lifecycle, withState, withHandlers, } from "recompose";
import { connect, } from "react-redux";
import * as contentful from "contentful-management";

import * as m from "src/components/style/mixins";
import * as v from "src/components/style/vars";
import * as consts from "src/consts";
import { plog, } from "src/lib/util";

import {
	GridCell,
} from "src/components/common";

import { SingleLineText, MultiLineText, } from "./text";
import { ImageUpload, } from "./image";

// --------------------------------------------------

const Wrapper = styled(GridCell)`
`;

const Name = styled.div`
	font-size: 1.2em;
	font-weight: bold;
	margin-bottom: 0.5em;
`;

const Fallback = () => <div>unknown field type</div>;

const uncamel = R.pipe(
	str => str.split(""),
	arr => arr.map((char, i) => (
		i === 0
		? char.toUpperCase()
		: (
			char.toUpperCase() === char
			? " " + char
			: char
		)
	)),
	arr => arr.join("")
);

// --------------------------------------------------

const inputsMap = {
	singleLine: SingleLineText,
	multiLine: MultiLineText,
	markdown: MultiLineText,
	assetLinkEditor: ImageUpload,
};

const Input = ({ type, content, setContent, }) => {
	const Comp = inputsMap[type] || Fallback;
	return (
		<Comp
			content = { content }
			setContent = { setContent }
		/>
	);
};

const Field = ({ name, type, content, setContent, }) => (
	<Wrapper>
		<Name>{ uncamel(name) }:</Name>
		<Input
			type = { type }
			content = { content }
			setContent = { setContent }
		/>
	</Wrapper>
);

export default Field;


// WEBPACK FOOTER //
// ./src/components/Editor/Pages/Field/index.js